import { render, staticRenderFns } from "./BasePetIcon.vue?vue&type=template&id=196350be&scoped=true&"
import script from "./BasePetIcon.vue?vue&type=script&lang=js&"
export * from "./BasePetIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196350be",
  null
  
)

export default component.exports